module.exports = __webpack_public_path__ + "static/google-sheets-import-da75767ed357febc87a2293ed15764db.svg";